import {
  Button,
  type DataResponse,
  Flex,
  formattedDate,
  FormControlSizes,
  HStack,
  request,
  Text,
  useEndpointsContext,
  useGlobalToasts,
} from '@talos/kyoko';
import { useCallback, useState } from 'react';
import type { UnqorkOrder } from './parsers/unqork';

export const CustomUnqorkUpload = ({ onUnqorkImport }: { onUnqorkImport: (rows: UnqorkOrder[]) => void }) => {
  const { add: addToast } = useGlobalToasts();
  const { orgApiEndpoint } = useEndpointsContext();
  const [loading, setLoading] = useState(false);

  const unqorkImport = useCallback(() => {
    const now = new Date();
    // Format to a date string like 2025-10-24
    const dateString = formattedDate(now, '{yyyy}-{MM}-{dd}');
    setLoading(true);
    request('GET', `${orgApiEndpoint}/unqork/orders?date=${dateString}`)
      .then((response: DataResponse<UnqorkOrder>) => {
        onUnqorkImport(response.data);
      })
      .catch((e: Error) => {
        addToast({
          variant: 'NEGATIVE',
          text: `Failed to import orders from unqork: ${e.message}`,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [orgApiEndpoint, addToast, onUnqorkImport]);

  return (
    <Flex flexDirection="column" gap="spacing6" h="100%">
      <HStack alignSelf="center" justifySelf="center" gap="spacing6" h="100%">
        <Text whiteSpace="nowrap">Import orders via API</Text>
        <Button
          size={FormControlSizes.Small}
          onClick={unqorkImport}
          loading={loading}
          data-testid="unqork-import-orders-button"
        >
          Import
        </Button>
      </HStack>

      {/* No CSV upload for unqork yet. */}
      {/* <FileArea onChange={onUpload} accept="text/csv" /> */}
    </Flex>
  );
};
